import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/jarl/Documents/Projects/civitas/kenobi/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Icon } from 'kenobi-ui';
import IconSearch from '../components/IconSearch';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "icon"
    }}>{`Icon`}</h1>
    <p>{`All Kenobi Icons comes from the `}<a parentName="p" {...{
        "href": "https://blueprintjs.com/docs/#icons"
      }}>{`@blueprintjs/icons`}</a>{` package.
Checkout their repo for information regarding license etc.`}</p>
    <p>{`All Icons render as an `}<inlineCode parentName="p">{`SVG`}</inlineCode>{` element. You can therefore not use it as a button. Checkout `}<a parentName="p" {...{
        "href": "/button"
      }}>{`Button`}</a>{` component instead.`}</p>
    <p>{`The Icon component is almost the same as Blueprint's.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`The default size for Icons are 16px. That size should fit most use cases.
However, you can resize the Icon by giving the `}<inlineCode parentName="p">{`size`}</inlineCode>{` prop.`}</p>
    <Playground __position={0} __code={'<Icon icon=\"build\" marginRight={16} />\n<Icon icon=\"endorsed\" size={40} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Icon,
      IconSearch
    }} mdxType="Playground">
  <Icon icon="build" marginRight={16} mdxType="Icon" />
  <Icon icon="endorsed" size={40} mdxType="Icon" />
    </Playground>
    <h2 {...{
      "id": "colours"
    }}>{`Colours`}</h2>
    <p>{`Presets: `}<inlineCode parentName="p">{`default`}</inlineCode>{` `}<inlineCode parentName="p">{`disabled`}</inlineCode>{` `}<inlineCode parentName="p">{`selected`}</inlineCode>{`
Intent: `}<inlineCode parentName="p">{`success`}</inlineCode>{` `}<inlineCode parentName="p">{`warning`}</inlineCode>{` `}<inlineCode parentName="p">{`danger`}</inlineCode></p>
    <p>{`You can also pass either an RGB value or HEX value instead of choosing a preset.`}</p>
    <p>{`You can also pass a `}<inlineCode parentName="p">{`Title`}</inlineCode>{` to the Icon. You know, for accessibility reasons.`}</p>
    <Playground __position={1} __code={'<Icon\n  title=\"Credit Card\"\n  icon=\"credit-card\"\n  color=\"default\"\n  marginRight={16}\n/>\n<Icon title=\"Download\" icon=\"download\" color=\"disabled\" marginRight={16} />\n<Icon title=\"Download\" icon=\"download\" color=\"selected\" marginRight={16} />\n<Icon title=\"Add awesomesauce\" icon=\"add\" color=\"primary\" marginRight={16} />\n<Icon\n  title=\"Endorse Kenobi\"\n  icon=\"endorsed\"\n  color=\"success\"\n  marginRight={16}\n/>\n<Icon title=\"Warning\" icon=\"warning-sign\" color=\"warning\" marginRight={16} />\n<Icon\n  title=\"Ban this guy\"\n  icon=\"ban-circle\"\n  color=\"danger\"\n  marginRight={16}\n/>\n<Icon icon=\"help\" color=\"info\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Icon,
      IconSearch
    }} mdxType="Playground">
  <Icon title="Credit Card" icon="credit-card" color="default" marginRight={16} mdxType="Icon" />
  <Icon title="Download" icon="download" color="disabled" marginRight={16} mdxType="Icon" />
  <Icon title="Download" icon="download" color="selected" marginRight={16} mdxType="Icon" />
  <Icon title="Add awesomesauce" icon="add" color="primary" marginRight={16} mdxType="Icon" />
  <Icon title="Endorse Kenobi" icon="endorsed" color="success" marginRight={16} mdxType="Icon" />
  <Icon title="Warning" icon="warning-sign" color="warning" marginRight={16} mdxType="Icon" />
  <Icon title="Ban this guy" icon="ban-circle" color="danger" marginRight={16} mdxType="Icon" />
  <Icon icon="help" color="info" mdxType="Icon" />
    </Playground>
    <h2 {...{
      "id": "icons"
    }}>{`Icons`}</h2>
    <IconSearch mdxType="IconSearch" />
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Icon} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      